module.exports = __webpack_public_path__ + "img/stat-icon-1.0375799f.png";